import { ActionName } from "@faire/web/common/performance/userPerceivedLoadTiming/types";

import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { shouldShowRscLoggedInSearchPage } from "@faire/retailer/views/search-v2/util/shouldShowRscLoggedInSearchPage";
import { shouldShowRscLoggedOutSearchPage } from "@faire/retailer/views/search-v2/util/shouldShowRscLoggedOutSearchPage";

export const useSearchPageActionName = (): ActionName => {
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (isFromDiscoverURL) {
    if (isLoggedInRetailer) {
      return shouldShowRscLoggedInSearchPage()
        ? "page-discover-logged-in-rsc"
        : "page-discover-logged-in";
    } else {
      return shouldShowRscLoggedOutSearchPage()
        ? "page-discover-logged-out-rsc"
        : "page-discover-logged-out";
    }
  } else {
    if (isLoggedInRetailer) {
      return shouldShowRscLoggedInSearchPage()
        ? "page-search-logged-in-rsc"
        : "page-search-logged-in";
    } else {
      return shouldShowRscLoggedOutSearchPage()
        ? "page-search-logged-out-rsc"
        : "page-search-logged-out";
    }
  }
};
